import "invokers-polyfill";
import "dialog-closedby-polyfill";
import anchorPositioningPolyfill from "@oddbird/css-anchor-positioning/fn";
import {processPolyfillWaitlist} from "../util/polyfill-helper";

window.waitForPolyfill = window.waitForPolyfill || {};
if (!("anchorName" in document.documentElement.style)) {
  anchorPositioningPolyfill().then(v => {
    console.debug("[polyfills] @oddbird/css-anchor-positioning applied", v);
    processPolyfillWaitlist("css-anchor-positioning");
  });
}
